(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_cba1024"] && !Shopify.designMode) return;
  try {
    (function () {
    // One delegated listener covers every promo bar, including ones the
    // theme editor re-renders.
    if (window.wmPromoCopyBound) return;
    window.wmPromoCopyBound = true;

    function legacyCopy(text) {
      // Selecting the helper textarea moves focus onto it; remember where
      // focus was so keyboard users land back on the code button.
      var active = document.activeElement;
      var area = document.createElement('textarea');
      area.value = text;
      area.setAttribute('readonly', '');
      area.style.position = 'fixed';
      area.style.top = '0';
      area.style.opacity = '0';
      area.style.fontSize = '16px';
      document.body.appendChild(area);
      area.select();
      var ok = false;
      try {
        ok = document.execCommand('copy');
      } catch (err) {
        ok = false;
      }
      document.body.removeChild(area);
      if (active && active !== document.body && active.isConnected !== false && typeof active.focus === 'function') {
        active.focus({ preventScroll: true });
      }
      return ok ? Promise.resolve() : Promise.reject(new Error('copy failed'));
    }

    function copyText(text) {
      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text).catch(function () {
          return legacyCopy(text);
        });
      }
      return legacyCopy(text);
    }

    function selectCode(button) {
      var target = button.querySelector('.wm-promo-bar__code-text') || button;
      var selection = window.getSelection ? window.getSelection() : null;
      if (!selection || !document.createRange) return;
      var range = document.createRange();
      range.selectNodeContents(target);
      selection.removeAllRanges();
      selection.addRange(range);
    }

    document.addEventListener('click', function (event) {
      var origin = event.target;
      if (!origin || typeof origin.closest !== 'function') return;
      var button = origin.closest('.wm-promo-bar__code');
      if (!button) return;

      var bar = button.closest('.wm-promo-bar');
      var status = bar ? bar.querySelector('.wm-promo-bar__status') : null;
      var code = button.getAttribute('data-code') || '';
      if (!code) return;

      copyText(code).then(function () {
        button.classList.add('is-copied');
        if (status) status.textContent = button.getAttribute('data-copied') || '';
        clearTimeout(button.wmCopyTimer);
        button.wmCopyTimer = setTimeout(function () {
          button.classList.remove('is-copied');
          if (status) status.textContent = '';
        }, 2000);
      }, function () {
        // Clipboard blocked: select the code so it can be copied by hand.
        selectCode(button);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
